<template>
    <div class="row">
        <div class="d-flex align-items-center gap-3">
            <basic-button
                icon="fi-rr-arrow-left"
                class="text-primary align-items-center pt-1 pe-2 ps-0 align-items-center btn"
                v-on:click="close"/>
            <div class="title small">
                {{ trans('general.defaults.add_new') }}
                {{ trans(`general.module.report.type.${type}`) }}
            </div>
        </div>
        <div :class="['col-12', {'col-lg-6': showInputsInline}]">
            <basic-input
                cls="mb-3"
                :label="trans(`general.page.settings.fields.label.${type}`)"
                v-model="model.label"
                :required="true"
                v-on:reset-error="errorFields.label = null"
                :error="errorFields.label"/>
        </div>
        <div :class="['col-12', {'col-lg-6': showInputsInline}]">
            <basic-date-picker
                v-if="getInputType() === 'time'"
                cls="mb-3"
                :label="trans(`general.page.settings.fields.value.${type}`)"
                mode="time"
                v-model="model.value"
                :required="true"
                v-on:reset-error="errorFields.value = null"
                :error="errorFields.value"/>

            <basic-input
                v-else
                cls="mb-3"
                :label="trans(`general.page.settings.fields.value.${type}`)"
                v-model="model.value"
                :required="true"
                v-on:reset-error="errorFields.value = null"
                :error="errorFields.value"/>
        </div>
        <div class="col-12 d-flex justify-content-end">
            <basic-button
                class="btn-success"
                :text="trans('general.defaults.add')"
                v-on:click="submit"
                :disabled="$wait.is(submitting)"
                :loading="$wait.is(submitting)"/>
        </div>
    </div>
</template>

<script>
import BasicInput from "../atoms/BasicInput.vue";
import BasicButton from "../atoms/BasicButton.vue";
import {handleErrors} from "../../services/ErrorHandler";
import BasicDatePicker from "../atoms/BasicDatePicker.vue";
import moment from "moment";
export const SUBMIT_INDICATOR = 'SUBMIT_INDICATOR';

export default {
    name: "AddSettingQuickForm",
    props: {
        type: String,
        showInputsInline: {
            type: Boolean,
            default: false
        }
    },
    components: {
        BasicDatePicker,
        BasicInput,
        BasicButton
    },
    data() {
        return {
            model: {
                label: null,
                value: null,
            },
            errors: [],
            errorFields: {
                label: null,
                value: null,
            }
        }
    },
    computed: {
        submitting() {
            return this.$wait.is(SUBMIT_INDICATOR);
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        getValue() {
            const map = {
                'meal': moment().format('HH:mm:ss'),
            };
            return map[this.type] ?? null;
        },
        getInputType() {
            const map = {
                'meal': 'time',
            };
            return map[this.type] ?? 'text';
        },
        getRouteSetting() {
            const routesMap = {
                'class': 'class-level',
                'food': 'food',
                'meal': 'meal',
                'meal_quantity': 'meal-quantity',
                'activity': 'activity',
                'billing': 'billing',
            };
            return routesMap[this.type] ?? this.type;
        },
        submit() {
            this.$wait.start(SUBMIT_INDICATOR);
            const {label, value} = this.model;
            const url = `/settings/${this.getRouteSetting()}/new`;

            axios.post(url, {label, value})
                .then(response => {
                    this.$wait.end(SUBMIT_INDICATOR);
                    this.$emit('save', response.data.data);
                })
                .catch((error) => {
                    this.$wait.end(SUBMIT_INDICATOR);
                   handleErrors(error, this, this.errorFields);
                });
        },
    },
    mounted() {
        this.model.value = this.getValue();
    }
}
</script>
